var map = {
	"./avatar_athena.png": 254,
	"./avatar_female.png": 695,
	"./avatar_hades.png": 388,
	"./avatar_male.png": 944,
	"./avatar_venus.png": 824,
	"./avatar_zeus.png": 443
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 801;